import { render, staticRenderFns } from "./newSummary.vue?vue&type=template&id=cf345ade"
import script from "./newSummary.vue?vue&type=script&lang=js"
export * from "./newSummary.vue?vue&type=script&lang=js"
import style0 from "./newSummary.vue?vue&type=style&index=0&id=cf345ade&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports